module.exports = __webpack_public_path__ + "static/media/non-disclusore-green.662a03f9.svg";